<template>
    <v-data-table
        :headers="headers"
        :items="list"
        :items-per-page="-1"
        class="elevation-1"
        :loading="loading"
        loading-text="Загрузка..."
        :footer-props="{
            disableItemsPerPage: true,
            'items-per-page-text':'Элементов на странице:',
            'items-per-page-all-text':'Все'
        }"
    >
         <template v-slot:top>
            <v-dialog
                v-model="dialogEdit"
                max-width="500px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        Добавить видео
                    </v-btn>
                </template>

                <v-card>
                    <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card color="basil" flat>
                        <v-card-text>
                            <v-text-field label="Наименование" v-model="editedItem.name"></v-text-field>
                        </v-card-text>
                    </v-card>
                    <v-card color="basil" flat>
                        <v-card-text>
                            <v-textarea label="Видео iframe" v-model="editedItem.data"></v-textarea>
                        </v-card-text>
                    </v-card>
                    <v-card v-if="editedItem.data && editedItem.data.indexOf('iframe') != 0" color="basil" flat>
                        <div class="video" v-html="editedItem.data" />
                    </v-card>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="closeEdit"
                        >
                            Отмена
                        </v-btn>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="save"
                        >
                            Сохранить
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
                title="Изменить видео"
            >
                $pencil
            </v-icon>
            <v-icon
                small
                class="mr-2"
                @click="chengeViewVideo(item)"
                title="Скрыть/показать видео, если глаз зчекрнут, то видео скрыто"
            >
                {{ item.hide ? '$eye-off' : '$eye' }}
            </v-icon>
            <v-icon
                small
                class="mr-2"
                @click="removeItem(item)"
                title="Удалить видео"
            >
                $delete
            </v-icon>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: "Videos",
    data() {
        return {
            list: [],
            headers: [
                {
                    value: "id",
                    text: "ID",
                    sortable: false,
                },
                {
                    value: "name",
                    text: "Название",
                    sortable: false,
                },
                {
                    value: 'actions',
                    text: 'Действия',
                    sortable: false,
                    align: 'end',
                },
            ],
            loading: false,
            dialogEdit: false,
            editedIndex: -1,
            editedItem: {
                id: 0,
                name: '',
                data: '',
                hide: false,
            },
            defaultItem: {
                id: 0,
                name: '',
                data: '',
                hide: false,
            },
        };
    },
    watch: {
        dialogEdit (val) {
            val || this.closeEdit();
        },
    },
    mounted() {
        this.getList();
    },
    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'Новое видео' : 'Редактирование видео #' + this.editedItem.id;
        },
    },
    methods: {
        async getList() {
            this.loading = true;

            try {
                const { list } = await this.$api('/admin/video');
                this.list = list;
            } catch (e) {
                this.$error(e.message);
            }

            this.loading = false;
        },
        editItem (item) {
            this.editedIndex = this.list.indexOf(item);
            item.data = `<iframe width="720" height="405" src="${item.data}" style="border: none;" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>`;
            this.editedItem = Object.assign({}, item);
            this.dialogEdit = true;
        },
        closeEdit () {
            this.dialogEdit = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        async save () {
            const method = this.editedIndex > -1 ? 'PUT' : 'POST';
            const alias = this.editedIndex > -1 ? `/admin/video/${this.editedItem.id}` : '/admin/video';
            const data = this.editedItem.data;

            if (!data) {
                this.$error('Iframe не задан');
                return;
            }

            if (!data.indexOf('iframe')) {
                this.$error('Iframe указан неверно');
                return;
            }

            const links = data.match(/https?:\/\/\S+/g) || [];
            
            if (!links.length || links.length > 1) {
                this.$error('Iframe указан неверно');
                return;
            }

            try {
                let r = await this.$api(alias, {
                    method: method,
                    body: {
                        name: this.editedItem.name,
                        data: links[0].replace('"', ""),
                        hide: this.editedItem.hide
                    }
                });
                if (!r.error) {
                    this.getList();
                    this.closeEdit();
                }
            } catch (e) {
                this.$error(e.message);
            }
        },
        async chengeViewVideo (item) {
            try {
                let r = await this.$api(`/admin/video/${item.id}` , {
                    method: 'PATCH',
                });
                if (!r.error) {
                    this.$success(`Видео успешно ${item.hide ? 'показано' : 'скрыто'}`);
                    this.getList();
                }
            } catch (e) {
                this.$error(e.message);
            }
        },
        async removeItem (item) {
            if (!confirm(`Удалить видео #${item.id}?`)) {
                return;
            }

            try {
                let r = await this.$api(`/admin/video/${item.id}`, {
                    method: 'DELETE',
                });
                if (!r.error) {
                    this.$success('Видео успешно удалено');
                    this.getList();
                }
            } catch (e) {
                this.$error(e.message);
            }
        }
    },
};
</script>

<style lang="scss">
    .video {
        width: 100% !important;
        height: auto !important;

        iframe {
            width: 100% !important;
            height: auto !important;
            min-height: 300px;
        }
    }
</style>
